export class IdHelper {

    public static generateRandomString(length: number): string {
        const buf = new Uint32Array(length);
        window.crypto.getRandomValues(buf);
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < length; i++) {
            result += characters.charAt(buf[i] % characters.length);
        }
        return result;
    }
}
